import {
  SignUpFreelancerBody,
  SignUpStakeholderBody,
  SignUpStudentBody,
} from "@/types/portalFunctionTypes";
import { axiosPublicClient } from "../axiosClient";

export const publicApi = {
  generatePasswordReset: async (email: string): Promise<void> => {
    return await axiosPublicClient.post("/public/generate-password-reset", {
      email,
    });
  },
  resendVerificationEmail: async (email: string): Promise<void> => {
    return await axiosPublicClient.post("/public/resend-verification-email", {
      email,
    });
  },
  generateSignInLink: async (email: string): Promise<void> => {
    return await axiosPublicClient.post("/public/generate-sign-in-link", {
      email,
    });
  },
  signUpStakeholder: async (data: SignUpStakeholderBody): Promise<any> => {
    return await axiosPublicClient.post("/public/sign-up-stakeholder", data);
  },
  signUpStudent: async (data: SignUpStudentBody): Promise<any> => {
    return await axiosPublicClient.post("/public/sign-up-student", data);
  },
  signUpFreelancer: async (data: SignUpFreelancerBody): Promise<any> => {
    return await axiosPublicClient.post("/public/sign-up-freelancer", data);
  }
};
